<template>
  <div :class="['position-relative', config.isInline && isTopBottomBar ? 'inline-element' : 'w-100']">
    <slot name="dropzone"></slot>
    <div class="w-100"/>
    <editor-overlay
        v-if="editable"
        :active="editorSelected"
        :can-have-template="true"
        :has-template="!!config.templateId"
        @removeBlock="$emit('removeBlock')"
        @editProperty="editProperty"
        @editTemplate="editTemplate"
    />

    <loading-spinner v-if="loading" />
    <template v-else>
      <BUTTON_ITEM
          v-for="project in projectsLists[config.uuid]"
          v-if="project.id !== projectId"
          :key="forceReRenderKey + project.id"
          :state="state"
          :config="{...config,
          linkedProjectId: project.id,
          uuid: uuidv4(),
          label: {
            dix: {
              Unknown: project.name
            }
          }
        }"
          :disabled="false"
          @goToProject="goToProject"
      />
    </template>
    <div v-if="!Object.keys(projectsLists[config.uuid]).length && editorMode">
      {{ $t('vform.noProjectsFound') }}
    </div>
    <div v-if="editorMode">
      ({{ $store.getters.getProjectListOptions(listName, 'pagination_items') }} {{ $t('vform.itemsFound') }}) <span v-if="currentProjectIsInList">({{ $t('vform.currentProjectExcluded')}})</span>
    </div>
  </div>
</template>

<script>
import ElementMixin from "@/components/vForm/mixins/ElementMixin.js.vue";
import LoadOverviewMixinJs from "@/components/mixins/LoadOverviewMixin.js.vue";
import EditorOverlay from "@/components/vForm/viewer/EditorOverlay.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {mapState} from "vuex";
import BUTTON_ITEM from "@/components/vForm/viewer/BUTTON_ITEM.vue";
import {v4 as uuidv4} from "uuid";
import {vformSettings} from "@/enum";

export default {
  name: "NAVIGATION",
  components: {EditorOverlay, LoadingSpinner, BUTTON_ITEM},
  mixins: [ElementMixin, LoadOverviewMixinJs],
  data() {
    return {
      vformSettings,
      registerMethod: 'registerProjectsQueryParams',
      loadMethod: 'loadProjects',
      listName: 'noname', // todo: do we need a separate list for this?
      forceReRenderKey: 0,
      queryRelevantComponents: 0,
      queryRelevantInits: 0,
      include: '',
      paginationLimit: 10
    }
  },
  computed: {
    ...mapState({
      projectsLists: state => state.projects.projectsLists
    }),
    currentProjectIsInList() {
      return (this.projectsLists[this.config.uuid] && this.projectsLists[this.config.uuid][this.projectId]);
    }
  },
  watch: {
    'config.alignment'() {
      this.forceReRenderKey++;
    },
    'config.textAlignment'() {
      this.forceReRenderKey++;
    },
    'config.settings': {
      handler() {
        this.doSearchIfFilter();
      },
      deep: true
    }
  },
  beforeMount() {
    this.listName = this.config.uuid;

    this.doSearchIfFilter();
    this.forceReRenderKey++;
  },
  methods: {
    uuidv4,
    goToProject(projectId) {
      this.$emit('goToProject', projectId);
    },
    async resetList() {
      await this.$store.commit('resetProjectListByName', this.listName);
      await this.$store.commit('resetProjectQueryParams', this.listName);
      this.forceReRenderKey++;
    },
    addTypeFilter(filter) {
      /**
       * add: {
       *                     filter: {
       *                         typeFilter: 'type eq vstage',
       *                     }
       *                 },
       * */
      const add = filter.add ? filter.add : {};
      if(!add.filter) {
        add.filter = {};
      }
      add.filter.typeFilter = 'type eq vstage';
      add.instanceTypes = {
        instanceTypeFilter: ['form']
      }
      add.instanceTypesRequired = {
        instanceTypeFilterRequired: true
      };
      filter.add = add;
      return filter;
    },
    async doSearchIfFilter() {
      const {settings} = this.config;
      await this.resetList();
      if(settings) {
        let {filter, sortBy, limit} = settings;
        if(!filter) {
          filter = {};
        }
        let separatedFilter = JSON.parse(JSON.stringify(filter));
        separatedFilter = this.addTypeFilter(separatedFilter ? separatedFilter : {});
        if (limit) {
          if(limit > vformSettings.MAX_LIMIT_DYNAMIC_NAVIGATION || limit < 1) {
            this.paginationLimit = 10;
          }
          else {
            this.paginationLimit = limit;
          }
        }
        this.sorting = sortBy ? sortBy : '-createdAt';
        if (separatedFilter && Object.keys(separatedFilter).length > 0) {
          console.log('Applying filter:', separatedFilter);

          await this.filtering(separatedFilter, false);
        }
      }
    }
  }
}
</script>